import React, { useContext } from 'react';
import { layoutContext } from '../../DORAAssessment';
import SingleOptionV2 from './SingleOptionV2';
import './QuestionsV2.scss';
import { Button } from 'carbon-components-react';
import { ArrowLeft16, Restart16 } from '@carbon/icons-react';
import { Scenario } from '../../../data/constants';
import PopUpV2 from '../PopUpV2/PopUpV2';
import PublicImage from 'src/common/components/PublicImage';
import ProgressBar from 'carbon-components-react/lib/components/ProgressBar';

interface questionsProps {
  contents: any;
  progressBarLabel: string;
}

const QuestionsV2 = (questionsProps: questionsProps) => {
  const { contents, progressBarLabel } = questionsProps;
  const {
    setCurrentScenario,
    selectedItems,
    setSelectedItems,
    setSelectedOption,
    questionId,
    setQuestionId,
    goToPrevious,
    setGoToPrevious,
  } = useContext(layoutContext);

  const handlePrevious = (qId: string) => {
    setQuestionId(qId);
    setGoToPrevious(true);
    setSelectedOption({
      optionId: '',
      nextStep: '',
    });
    setSelectedItems((current: any) => {
      const itemsCopy = { ...current };

      delete itemsCopy[questionId];

      return itemsCopy;
    });
  };

  const handleRestart = () => {
    setSelectedItems({});
    setSelectedOption({
      optionId: '',
      nextStep: '',
    });
    setQuestionId('q1');
    setCurrentScenario(Scenario.introduction);
    setGoToPrevious(false);
  };

  const selectedItemsArray = Object.values(selectedItems);
  const lengthOfArray = selectedItemsArray.length;
  const maxLength = 10;
  const percentage = (lengthOfArray / maxLength) * 100;
  return (
    <div style={{ margin: 0 }}>
      {contents.map((question: any, i: number) => {
        const questionNumber = i + 1;
        if (question.id === questionId) {
          return (
            <div className="dora-assessment-v2">
              <div className="bx--row" key={questionId + '-progress'}>
                <div className="bx--col-lg-12 progress-bar">
                  <ProgressBar
                    label={progressBarLabel}
                    value={lengthOfArray > 0 ? percentage : 10}
                    max={100}
                  />
                </div>
              </div>
              <div className="bx--row" key={questionId}>
                <div className="bx--col-lg-6 bx--col-md-8 bx--col-sm-4 dora-assessment-v2__question-wrapper">
                  <p className="dora-assessment-v2__question-indicator">
                    {questionNumber + '. '}
                    {question.title}
                  </p>
                  {question.popUp ? (
                    <PopUpV2 contents={question.popUp} />
                  ) : null}
                  <div className="dora-assessment-v2__question-cta_desktop">
                    <Button
                      kind="tertiary"
                      className="dora-assessment-v2__question-cta-previous"
                      onClick={() => handleRestart()}
                    >
                      <Restart16 className="restart_icon" />
                    </Button>
                    <Button
                      kind="tertiary"
                      disabled={i <= 0}
                      className="dora-assessment-v2__question-cta-previous"
                      onClick={() => handlePrevious(contents[i - 1].id)}
                    >
                      <ArrowLeft16 />
                    </Button>
                  </div>
                </div>
                <div className="bx--col-lg-10 bx--col-md-8 bx--col-sm-4 dora-assessment-v2__answer-wrapper">
                  <SingleOptionV2 options={question.options} />
                  <PublicImage
                    imgPath={`${question.imageSrc}`}
                    widgetId="dora-assessment"
                    className="dora-assessment-v2__question-image"
                    alt={``}
                  />
                </div>
                <div className="bx--col-sm-1 bx--col-md-1 dora-assessment-v2__question-cta">
                  <div className="dora-assessment-v2__question-cta_mobile">
                    <Button
                      kind="tertiary"
                      className="dora-assessment-v2__question-cta-previous"
                      onClick={() => handleRestart()}
                    >
                      <Restart16 className="restart_icon" />
                    </Button>
                    <Button
                      kind="tertiary"
                      disabled={i <= 0}
                      className="dora-assessment-v2__question-cta-previous"
                      onClick={() => handlePrevious(contents[i - 1].id)}
                    >
                      <ArrowLeft16 />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default QuestionsV2;
